import { render, staticRenderFns } from "./ServiceView.vue?vue&type=template&id=75250404&scoped=true"
import script from "./ServiceView.vue?vue&type=script&lang=js"
export * from "./ServiceView.vue?vue&type=script&lang=js"
import style0 from "./ServiceView.vue?vue&type=style&index=0&id=75250404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1c848d52c9dbe574bb8312e4e1e1d32e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75250404",
  null
  
)

export default component.exports